import { makeStyles } from 'tss-react/mui';

const useStickerStyles = makeStyles()((theme) => ({
    width: {
        maxWidth: theme.spacing(20),
        [theme.breakpoints.up('xl')]: {
            maxWidth: theme.spacing(24),
            minWidth: theme.spacing(24),
        },
    },
    minWidth: {
        minWidth: theme.spacing(20),
        [theme.breakpoints.up('xl')]: {
            minWidth: theme.spacing(24),
        },
    },

    title: {
        height: theme.spacing(4),
    },
    titleText: {
        fontSize: theme.spacing(1.6),
        lineHeight: theme.spacing(1.6),
        [theme.breakpoints.up('xl')]: {
            fontSize: theme.spacing(2),
            lineHeight: theme.spacing(2),
        },
    },
    bodyText: {
        lineHeight: theme.spacing(2.4),
        fontSize: theme.spacing(2.4),
        [theme.breakpoints.up('xl')]: {
            lineHeight: theme.spacing(3),
            fontSize: theme.spacing(3),
        },
    },

    proceedButton: {
        height: theme.spacing(5),
        lineHeight: theme.spacing(1.6),
        fontSize: theme.spacing(1.6),
        '&.primary': {
            background: theme.palette.primary.main,
            color: theme.palette.getContrastText(theme.palette.primary.main),
        },
        '&.secondary': {
            background: theme.palette.secondary.main,
            color: theme.palette.getContrastText(theme.palette.secondary.main),
            '&:hover': {
                background: theme.palette.primary.main,
                color: theme.palette.getContrastText(theme.palette.primary.main),
            },
        },
        [theme.breakpoints.up('xl')]: {
            fontSize: theme.spacing(2),
            lineHeight: theme.spacing(2),
        },
        '&.small': {
            height: theme.spacing(4),
        },
    },
}));

export default useStickerStyles;
